import './App.css';
import './Totem2.css';

import AdCreative from './AdCreative';
function Totem2({
    creativeURL,
    creativeExt,
    color,
    width,
    height,
    baseColor,
}) {
    return (
        <div className='mk2-p'>
            <div className='mk2-totem-cover'>
                <div
                    className='mk2-totem'
                    style={{
                        width: width,
                        height: height,
                        backgroundColor: color,
                    }}
                >
                    <div
                        className='mk2-totem-screen'
                    >
                        <AdCreative
                            creativeURL={creativeURL}
                            creativeExt={creativeExt ?? 'mp4'}
                            shouldAutoPlay={true}
                            hideControls={true}
                            isMuted={true}
                            height='100%'
                            width='100%'
                            objectFit='contain'
                        />
                    </div>
                </div>
            </div>
            <div className='mk2-totem-support-container'>
                <div
                    className='mk2-totem-support'
                    style={{ backgroundColor: baseColor }}
                />
            </div>
        </div>
    );
}

export default Totem2;